import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import pressReleaseImage from '../img/press-release.jpg';
import influencerMarketing from '../img/influencer.avif';

const BlogPage = () => {
  const { id } = useParams();
  const [activeCategory, setActiveCategory] = useState('All');

  const blogPosts = [
    {
      id: 1,
      title: "5 Proven Digital Marketing Strategies Vibex Media Uses to Boost Impact for Non-Profits and Service Companies (Featuring GNI & Arvarta)",
      content: `
    <p>In today’s competitive online landscape, <a href="https://vibex.media" target="_blank" rel="noopener noreferrer"><strong>Vibex Media</strong></a> is redefining <strong>digital marketing for non-profits</strong> and service-based organizations. By combining creativity with data-driven insights, Vibex Media helps partners like <a href="https://globalnursesinitiative.com/" target="_blank" rel="noopener noreferrer"><strong>Global Nurses Initiative (GNI)</strong></a> and <a href="http://aryavarta.ca/" target="_blank" rel="noopener noreferrer"><strong>Arvarta</strong></a> expand their reach, attract donors, and drive meaningful community engagement. Every campaign we design aims to inspire action — not just awareness.</p>

    <h4>1. Audience-Focused Storytelling That Inspires Change</h4>
    <p>The heart of effective <strong>social impact marketing</strong> lies in storytelling. Vibex Media helps non-profits like GNI and Arvarta communicate their missions through emotionally driven narratives. We transform their causes into powerful, relatable stories that connect with audiences across digital platforms. This approach boosts online engagement, volunteer participation, and long-term trust.</p>

    <h4>2. Multi-Platform Advertising for Maximum Visibility</h4>
    <p>Whether it’s <strong>Google Ads, Meta campaigns, or YouTube storytelling</strong>, Vibex Media ensures every partner’s message reaches the right people at the right time. For organizations such as Arvarta and GNI, this means maintaining a strong online presence across multiple platforms — increasing brand visibility and donor conversions while keeping ad costs optimized.</p>

    <h4>3. SEO & Content Optimization That Builds Credibility</h4>
    <p>Ranking on search engines is vital for any mission-driven organization. Vibex Media leverages <strong>SEO for NGOs and service companies</strong> to boost organic visibility. From keyword research to on-page optimization, we ensure that organizations like GNI and Arvarta are easily discoverable by supporters and collaborators. Consistent, SEO-rich content helps build authority and credibility in their niche.</p>

    <h4>4. Analytics, Tracking, and Measurable Growth</h4>
    <p>What makes Vibex Media stand out is our commitment to transparency and performance measurement. We use advanced analytics and conversion tracking to evaluate every campaign’s impact. For partners like GNI and Arvarta, this means gaining insights into audience behavior, donation trends, and digital performance — empowering them to make smarter marketing decisions with clear ROI.</p>

    <h4>5. Collaboration with VMS Labs for AI-Powered Digital Transformation</h4>
    <p>Technology fuels innovation, and this is where <a href="https://vmslabs.com" target="_blank" rel="noopener noreferrer"><strong>VMS Labs</strong></a> comes in. Vibex Media collaborates with VMS Labs to integrate <strong>AI-powered marketing tools</strong>, automation systems, and performance dashboards that simplify campaign management for non-profits. Together, Vibex Media, VMS Labs, Arvarta, and GNI are setting new benchmarks for <strong>data-driven marketing in the social sector</strong>.</p>

    <p>Every story we create, every ad we launch, and every campaign we measure has one goal — to amplify the impact of mission-led organizations. Explore how <a href="https://vibex.media" target="_blank" rel="noopener noreferrer"><strong>Vibex Media</strong></a> and <a href="https://vmslabs.com" target="_blank" rel="noopener noreferrer"><strong>VMS Labs</strong></a> are transforming digital marketing for non-profits and service companies like <a href="https://globalnursesinitiative.com/" target="_blank" rel="noopener noreferrer"><strong>GNI</strong></a> and <a href="http://aryavarta.ca/" target="_blank" rel="noopener noreferrer"><strong>Arvarta</strong></a> — empowering them to inspire, grow, and make a lasting difference online.</p>
  `,
      date: "November 2025",
      category: "Marketing Insights",
      image: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=2070&q=80",
      readTime: "7 min read",
      author: "Vibex Media Team",
      authorImage: "https://randomuser.me/api/portraits/men/45.jpg"
    },

    {
  id: 2,
  title: "How Vibex Media and VMS Labs Are Transforming Brand Storytelling with AI (Featuring GNI & Arvarta)",
  excerpt: "Discover how Vibex Media and VMS Labs are reshaping digital storytelling with AI, helping brands like GNI and Arvarta inspire audiences with data-driven creativity.",
  content: `
    <p>In the digital-first era, storytelling is no longer just about creativity — it’s about connection, precision, and personalization. That’s where <a href="https://vibex.media" target="_blank" rel="noopener noreferrer"><strong>Vibex Media</strong></a> and <a href="https://vmslabs.com" target="_blank" rel="noopener noreferrer"><strong>VMS Labs</strong></a> are making waves. Together, they are redefining how organizations craft their digital identity by merging human creativity with artificial intelligence.</p>

    <h4>1. The Shift from Traditional Storytelling to AI-Enhanced Narratives</h4>
    <p><strong>Vibex Media</strong> understands that every brand — whether it’s a non-profit like <a href="https://globalnursesinitiative.com/" target="_blank" rel="noopener noreferrer"><strong>Global Nurses Initiative (GNI)</strong></a> or a community-driven project like <a href="http://aryavarta.ca/" target="_blank" rel="noopener noreferrer"><strong>Arvarta</strong></a> — has a unique story to tell. With the rise of AI tools developed by <strong>VMS Labs</strong>, those stories can now reach the right audience more effectively through data-backed creativity.</p>

    <h4>2. Personalization at Scale</h4>
    <p>Through <a href="https://vmslabs.com" target="_blank" rel="noopener noreferrer"><strong>VMS Labs’ AI automation</strong></a>, Vibex Media delivers hyper-personalized storytelling experiences. For example, when organizations like <a href="https://globalnursesinitiative.com/" target="_blank" rel="noopener noreferrer"><strong>GNI</strong></a> or <a href="http://aryavarta.ca/" target="_blank" rel="noopener noreferrer"><strong>Arvarta</strong></a> connect with diverse communities, AI helps segment audiences based on interests and values — ensuring every message resonates authentically.</p>

    <h4>3. Visual Creativity Meets Smart Technology</h4>
    <p>From brand videos to interactive campaigns, <strong>Vibex Media</strong> integrates creative design with AI-enhanced production techniques provided by <strong>VMS Labs</strong>. This collaboration ensures every visual element — from tone to color palette — aligns perfectly with audience emotion and intent.</p>

    <h4>4. Data-Driven Insights for Continuous Growth</h4>
    <p>Vibex Media’s partnership with <strong>VMS Labs</strong> ensures every storytelling campaign is measurable. Advanced dashboards track engagement and sentiment, empowering partners like <a href="https://globalnursesinitiative.com/" target="_blank" rel="noopener noreferrer"><strong>GNI</strong></a> and <a href="http://aryavarta.ca/" target="_blank" rel="noopener noreferrer"><strong>Arvarta</strong></a> to understand what truly connects with their audiences.</p>

    <h4>5. The Future of Brand Storytelling</h4>
    <p>The collaboration between <strong>Vibex Media</strong> and <strong>VMS Labs</strong> marks a new chapter in storytelling — one where creativity meets intelligence. Together, they’re helping mission-led organizations like <a href="https://globalnursesinitiative.com/" target="_blank" rel="noopener noreferrer"><strong>GNI</strong></a> and <a href="http://aryavarta.ca/" target="_blank" rel="noopener noreferrer"><strong>Arvarta</strong></a> build authentic digital voices that inspire, educate, and drive change.</p>

    <p>To explore how AI and creativity can revolutionize your brand’s story, visit <a href="https://vibex.media" target="_blank" rel="noopener noreferrer"><strong>Vibex Media</strong></a> — in collaboration with <a href="https://vmslabs.com" target="_blank" rel="noopener noreferrer"><strong>VMS Labs</strong></a> — and see how innovation and purpose can come together to make a lasting impact online.</p>
  `,
  date: "November 2025",
  category: "AI & Branding",
  image: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=2070&q=80",
  readTime: "7 min read",
  author: "Vibex Media Team",
  authorImage: "https://randomuser.me/api/portraits/women/65.jpg"
}

  ];

  const categories = ['All', ...new Set(blogPosts.map(post => post.category))];
  const filteredPosts = activeCategory === 'All'
    ? blogPosts
    : blogPosts.filter(post => post.category === activeCategory);

  const selectedBlog = blogPosts.find(post => post.id === Number(id));

  // If blog id in URL, show full blog view
  if (selectedBlog) {
    return (
      <section className="blog-detail py-5">
        <div className="container">
          <Link to="/blogs" className="btn btn-outline-primary mb-4">
            ← Back to Blogs
          </Link>
          <div className="row">
            <div className="col-lg-10 mx-auto">
              <img src={selectedBlog.image} alt={selectedBlog.title} className="img-fluid mb-4 rounded-3 shadow" />
              <h1 className="fw-bold mb-3">{selectedBlog.title}</h1>
              <p className="text-muted mb-4">
                {selectedBlog.date} · {selectedBlog.readTime}
              </p>
              <div className="d-flex align-items-center mb-4">
                <img
                  src={selectedBlog.authorImage}
                  alt={selectedBlog.author}
                  className="rounded-circle me-3"
                  width="50"
                />
                <div>
                  <h6 className="mb-0">{selectedBlog.author}</h6>
                  <small className="text-muted">{selectedBlog.category}</small>
                </div>
              </div>
              <div
                className="blog-content"
                dangerouslySetInnerHTML={{ __html: selectedBlog.content }}
              />
            </div>
          </div>
        </div>
      </section>
    );
  }

  // Otherwise show blog list
  return (
    <section className="blog-page py-5">
      <div className="container">
        <div className="row mb-5">
          <div className="col-lg-8 mx-auto text-center">
            <h1 className="display-4 fw-bold mb-3">Impact & Innovation Blog</h1>
            <p className="lead text-muted">Expert articles and latest trends in advertising, marketing, and brand strategy.</p>
          </div>
        </div>

        <div className="row mb-4">
          <div className="col-12 text-center">
            {categories.map(category => (
              <button
                key={category}
                className={`btn ${activeCategory === category ? 'btn-primary' : 'btn-outline-primary'} rounded-pill mx-2`}
                onClick={() => setActiveCategory(category)}
              >
                {category}
              </button>
            ))}
          </div>
        </div>

        <div className="row g-4">
          {filteredPosts.map(post => (
            <div key={post.id} className="col-lg-4 col-md-6">
              <div className="card border-0 shadow-sm h-100">
                <img src={post.image} className="card-img-top" alt={post.title} />
                <div className="card-body">
                  <span className="badge bg-primary mb-2">{post.category}</span>
                  <h3 className="h5">{post.title}</h3>
                  <p className="text-muted">{post.excerpt}</p>
                  <Link to={`/blog/${post.id}`} className="btn btn-sm btn-primary mt-2">
                    Read More →
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogPage;
